import { Fragment,useEffect} from '@wordpress/element';
import { InnerBlocks, useBlockProps, __experimentalBlockVariationPicker } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import { useSelect, useDispatch } from '@wordpress/data';
import { createBlocksFromInnerBlocksTemplate } from '@wordpress/blocks';
import { Placeholder } from '@wordpress/components';
import { useInstanceId} from '@wordpress/compose';
import classnames from 'classnames';
import InsSettings from './settings.js';
import './editor.scss';
import { grid } from '@wordpress/icons';
import {
	titleDateExcerpt,
	imageDateTitle,
} from './icons';

import { VayuBlocksDevice } from '@vayu-blocks/device-control';
import { VayuBlocksUniqueId } from "@vayu-blocks/global";
import { VayuBlockAdvanceStyle } from '@vayu-blocks/advance-panel/style.js';

const Edit = (props) => {

    const { attributes, setAttributes, clientId, isSelected } = props;

    const { mergedStyles, handleMouseEnter, handleMouseLeave } = VayuBlockAdvanceStyle(attributes);

    const { replaceInnerBlocks } = useDispatch('core/block-editor');

    // Define block variations
    const blockVariations = [
        {
            name: 'layout-one',
            title: __('Default', 'vayu-blocks'),
            icon: titleDateExcerpt,
            innerBlocks: [
                [
                    'vayu-blocks/wrapper', 
                    {
                        layoutType:'list'
                    }, 
                    [
                        [
                            'vayu-blocks/advance-container', 
                            {   
                              contFlex:{
                                direction:{
                                    Desktop: "column",
                                    Tablet: "column",
                                    Mobile: "column"
                                }
                               },
                               advPadding:{
                                Desktop: "0px",
                                Tablet: "0px",
                                Mobile: "0px"
                              },
                              advMargin:{
                                Desktop: "0px",
                                Tablet: "0px",
                                Mobile: "0px"
                              }
 
                            }, 
                            [
                                   ['vayu-blocks/advance-heading',
                                    { 
                                    title: __('Post Title', 'vayu-blocks'),	
                                    placeholder: __('Post Title', 'vayu-blocks'),
                                    selectedSourceField:'title',
                                    
                                    }
                                    ],
                                    
                                    ['vayu-blocks/advance-heading', 
                                    { 
                                        title: __('Post Date', 'vayu-blocks'),
                                        placeholder: __('Post Date', 'vayu-blocks'),
                                        tag: 'span',
                                        selectedSourceField:'post_date',
                                        
                                    }],

                                    ['vayu-blocks/advance-heading', 
                                        { 
                                            title: __('Post Excerpt', 'vayu-blocks'),
                                            placeholder: __('Post Excerpt', 'vayu-blocks'),
                                            tag: 'span',
                                            selectedSourceField:'excerpt',
                                            
                                    }]
                            ]
                        ]
                    ]
                ],
                ['vayu-blocks/post-pagination']
            ]
        },
        {
            name: 'layout-two',
            title: __('grid', 'vayu-blocks'),
            icon: grid,
            innerBlocks: [
                [
                    'vayu-blocks/wrapper', 
                    {
                        layoutType:'grid',
                        gridColumn:'3'
                    }, 
                    [
                        [
                            'vayu-blocks/advance-container', 
                            {
                                contFlex:{
                                    direction:{
                                        Desktop: "column",
                                        Tablet: "column",
                                        Mobile: "column"
                                    }
                                   },
                                   advPadding:{
                                    Desktop: "0px",
                                    Tablet: "0px",
                                    Mobile: "0px"
                                  },
                                  advMargin:{
                                    Desktop: "0px",
                                    Tablet: "0px",
                                    Mobile: "0px"
                                  }
                            }, 
                            [
                                ['vayu-blocks/advance-heading',
                                { 
                                title: __('Post Featured Image', 'vayu-blocks'),	
                                placeholder: __('Post Featured Image', 'vayu-blocks'),
                                selectedSourceField:'post_image',
                                }
                                ],
                                   ['vayu-blocks/advance-heading',
                                    { 
                                    title: __('Post Title', 'vayu-blocks'),	
                                    placeholder: __('Post Title', 'vayu-blocks'),
                                    selectedSourceField:'title',
                                    
                                    }
                                    ],
                                    
                                    ['vayu-blocks/advance-heading', 
                                    { 
                                        title: __('Post Date', 'vayu-blocks'),
                                        placeholder: __('Post Date', 'vayu-blocks'),
                                        tag: 'span',
                                        selectedSourceField:'post_date',
                                       
                                    }]

                            ]
                        ]
                    ]
                ],
                ['vayu-blocks/post-pagination']
            ]
        },
        {
            name: 'layout-three',
            title: __('Image', 'vayu-blocks'),
            icon: imageDateTitle,
            innerBlocks: [
                [
                    'vayu-blocks/wrapper', 
                    {
                        layoutType:'list',
                       
                    }, 
                    [
                        [
                            'vayu-blocks/advance-container', 
                            {
                                contFlex:{
                                    direction:{
                                        Desktop: "column",
                                        Tablet: "column",
                                        Mobile: "column"
                                    }
                                   },
                                   advPadding:{
                                    Desktop: "0px",
                                    Tablet: "0px",
                                    Mobile: "0px"
                                  },
                                  advMargin:{
                                    Desktop: "0px",
                                    Tablet: "0px",
                                    Mobile: "0px"
                                  }
                            }, 
                            [      
                                  ['vayu-blocks/advance-heading',
                                    { 
                                    title: __('Post Featured Image', 'vayu-blocks'),	
                                    placeholder: __('Post Featured Image', 'vayu-blocks'),
                                    selectedSourceField:'post_image',
                                    }
                                    ],
                                   
                                    
                                    ['vayu-blocks/advance-heading', 
                                    { 
                                        title: __('Author Name', 'vayu-blocks'),
                                        placeholder: __('Author Nam', 'vayu-blocks'),
                                        tag: 'span',
                                        selectedSourceField:'author_name',
                                        
                                    }],  
                                    
                                    ['vayu-blocks/advance-heading',
                                        { 
                                        title: __('Post Title', 'vayu-blocks'),	
                                        placeholder: __('Post Title', 'vayu-blocks'),
                                        selectedSourceField:'title',
                                        
                                        }
                                        ],
                            ]
                        ]
                    ]
                ],
                ['vayu-blocks/post-pagination']
            ]
        }
    ];
    

    // Handle variation selection
    const onSelectVariation = (variation) => {
        if (variation.innerBlocks) {
            const innerBlocks = createBlocksFromInnerBlocksTemplate(variation.innerBlocks);
            replaceInnerBlocks(clientId, innerBlocks, false); // Replace with selected variation blocks
        }
    };

    // Check if there are inner blocks already
    const hasInnerBlocks = useSelect(
        (select) => !!select('core/block-editor').getBlocks(clientId).length,
        [clientId]
    );
    
    const { queryId } = attributes;
    const instanceId = useInstanceId(Edit);

    // Set the queryId if not already set
    useEffect(() => {
        if (!queryId) {
            setAttributes({ queryId: instanceId });
        }
    }, [queryId, instanceId, setAttributes]);

    VayuBlocksUniqueId({ 
            setAttributes: setAttributes, 
            clientId: clientId
        });
    
    const deviceView = VayuBlocksDevice();
       
    const omitBy = (object, condition) => (
                Object.fromEntries(
                Object.entries(object).filter(([key, value]) => !condition(value))
                )
    );

    let loopClasses = classnames({
       'th-hide-desktop': attributes.advResponsive?.Desktop === true,
    'th-hide-tablet': attributes.advResponsive?.Tablet === true,
    'th-hide-mobile': attributes.advResponsive?.Mobile === true,  
    });
          
          const style = omitBy({
                ...mergedStyles,
            }, x => x?.includes?.( 'undefined' ));

            const blockProps = useBlockProps({
                className:loopClasses,
                style
            });

            const queryBlockProps = {
                ...blockProps,
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave,
            };

    return (
        <Fragment>
             {isSelected && 
                <InsSettings
                {...props}
                />
             }
            <div {...queryBlockProps}>
                {!hasInnerBlocks && (
                    <Placeholder
                        label={__('Advance Query Block', 'vayu-blocks')}
                        instructions={__('Select a variation to start with:', 'vayu-blocks')}
                    >
                        <__experimentalBlockVariationPicker
                            icon="layout"
                            label={__('Choose a layout', 'vayu-blocks')}
                            variations={blockVariations}
                            onSelect={onSelectVariation}
                        />
                    </Placeholder>
                )}
                {hasInnerBlocks && <InnerBlocks/>
                }
            </div>
        </Fragment>
    );
};

export default Edit;